"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _upload = _interopRequireDefault(require("./upload.vue"));
var _expert = require("@/api/expert/expert");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  props: {
    textInfo: {
      Object: Object
    },
    id: [String]
  },
  data: function data() {
    return {
      accept: ".doc,.docx",
      dialogTableVisible1: false,
      getUrl: ""
    };
  },
  methods: {
    changShow: function changShow() {
      this.dialogTableVisible1 = true;
    },
    surefilein: function surefilein() {
      var _this = this;
      (0, _expert.getExpertCheckedInfo)({
        matchId: this.id,
        url: this.getUrl
      }).then(function (res) {
        _this.$message.success("操作成功。");
        _this.dialogTableVisible1 = false;
      });
    },
    cancel: function cancel() {
      this.dialogTableVisible1 = false;
    },
    successData: function successData(e, url) {
      this.getUrl = url;
      this.excelFile = e.raw;
    },
    downLoadSymble: function downLoadSymble(e) {
      var fileIndex = e.lastIndexOf(".");
      var fileEnd = e.substr(fileIndex);
      var a = document.createElement("a");
      fetch(e).then(function (res) {
        return res.blob();
      }).then(function (blob) {
        a.href = URL.createObjectURL(blob);
        console.log(a.href);
        a.download = "承诺书模板" + fileEnd; // 下载文件的名字
        document.body.appendChild(a);
        a.click();
      });
    }
  },
  components: {
    ExcelUpload: _upload.default
  }
};